<template>
  <div>
    <div
      v-if="loading"
      class="flex items-center justify-center mt-10"
      :class="containerClass"
    >
      <SkeletonLoader />
    </div>
    <div v-else>
      <div v-if="properties" :class="containerClass">
        <div v-for="property in properties" :key="property.id">
          <div
            class="w-full md:h-[294px] border border-gray-200 rounded-xl mt-8"
            :class="containerClass"
          >
            <button
              @click.prevent="handlePropertyClick(property, routeName)"
              @mouseover="handleAdHoverStart()"
              @mouseout="handleAdHoverEnd(property.id)"
              class="flex flex-col w-full md:flex-row"
            >
              <ImageView :property="property" />
              <PropertyDescription :property="property" />
            </button>
            <CardFooter :property="property" />
          </div>
        </div>
      </div>
      <div
        v-else-if="properties.length <= 0"
        class="md:w-[825px] mt-10 flex justify-center items-center"
      >
        <p class="text-sm text-stone-900">No properties</p>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, watch, computed } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import ImageView from "@/features/properties/components/ImageView.vue";
import PropertyDescription from "@/features/properties/components/PropertyDescription.vue";
import SkeletonLoader from "@/components/SkeletonLoader.vue";
import CardFooter from "./components/CardFooter.vue";
import { useProperties } from "@/composables/useProperties";

export default {
  name: "PropertyCard",
  components: {
    ImageView,
    PropertyDescription,
    SkeletonLoader,
    CardFooter,
  },
  props: {
    properties: {
      type: Array,
      required: true,
    },
    isFullWidth: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const loading = ref(true);
    const isDropdownOpen = ref(false);
    const store = useStore();
    const router = useRouter();
    const base_url = store.state.baseUrl;
    const routeName = router.currentRoute.value.fullPath;

    const { handleAdHoverStart, handleAdHoverEnd, handlePropertyClick } =
      useProperties();

    watch(
      () => props.properties,
      (newVal) => {
        if (newVal && newVal.length >= 0) {
          setTimeout(() => {
            loading.value = false;
          }, 1000);
        }
      },
      { immediate: true }
    );

    const containerClass = computed(() =>
      props.isFullWidth ? "w-full" : "md:w-[825px]"
    );

    const toggleDropdown = () => {
      isDropdownOpen.value = !isDropdownOpen.value;
    };

    return {
      loading,
      isDropdownOpen,
      base_url,
      containerClass,
      toggleDropdown,
      handleAdHoverStart,
      handleAdHoverEnd,
      handlePropertyClick,
      routeName,
    };
  },
};
</script>
